export enum UserAchievementStatus {
  Incomplete = 'incomplete',
  Completed = 'completed',
  Failed = 'failed',
}

export type UserAchievement = {
  achievementId: string;
  chainKey: string | undefined;
  title: string;
  description: string;
  congratulatoryMessage: string;
  tier: number | undefined;
  imageUrl: string | undefined;
  unitsRequired: number;

  id: string | null;
  userId: string | null;
  createdAt: Date;
  updatedAt: Date;
  status: UserAchievementStatus;
  unitsProgress: number;
};
